import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import Spinner from "./components/Spinner";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css"; // Add the CSS provided
import ServiceSection from "./components/ServiceSection";
import AboutSection from "./components/AboutSection";
import TeamSection from "./components/TeamSection";
import Footer from "./components/Footer";
import Categories from "./components/Categories";
import Courses from "./components/Courses";
import Testimonial from "./components/Testimonial";
import HomePage from "./components/HomePage";
import ContactUs from "./components/Contact";
// import AboutDiksha from "./components/AboutDiksha";
import WhyChoose from "./components/WhyChoose";
import Sliders from "./components/Sliders";
import Clients from "./components/Clients";

import Register from "./components/Register";
import CourseDetails from "./components/CourseDetails";
import Gallery from "./components/Gallery";
import Blog from "./components/Blog";
import Aimi from "./components/Aimi";
import CloudComputing from './components/CloudComputing';
import DataAnalytics from './components/DataAnalytics';
import DataEngineering from './components/DataEngineering';
import AIFundamentals from "./components/AiFundamentals";
import AIDeveloper from "./components/AiDeveloper";
import DataScienceCourse from "./components/DataScienceCourse";
import AiProfessional from "./components/AiProfessional";
import Aws from "./components/Aws";
import Azure from "./components/Azure";
import Gcp from "./components/Gcp";
import Tableau from "./components/Tableau";
import Looker from "./components/Looker";
import PowerBi from "./components/powerBi";
import FullStackWeb from "./components/FullStackWeb";
import Oracle from "./components/Oracle";
import CloudEngineering from "./components/CloudEngineering";
import MobileDevelopment from "./components/MobileDevelopment";
import ProjectManager from "./components/ProjectManager";
import ProgrammingCourse from "./components/ProgrammingCourses";
import Deveops from "./components/Deveops";
import Blogger from "./components/Blogger"; // Import the Blogger component
import BlogTitle from "./components/BlogTitle";
import Login from "./components/Login";
import Admin from "./components/admin"
import User from "./components/user";
import PostView from "./components/PostView"; 
import AiImage from "./components/AiImage";// Import the PostView component

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    //  <Router basename="/diksha/" >
   <Router >
      {loading && <Spinner />}

      <Navbar />
      <Header />

      {/* Routes section */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutSection />} />
        <Route path="/our-team" element={<TeamSection />} />
        <Route path="/services" element={<ServiceSection />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/why" element={<WhyChoose />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/slide" element={<Sliders />} />
        <Route path='/Clients' element={<Clients/>}/>
        <Route path="/register" element={<Register />} />
        <Route path="/coursedetails" element={<CourseDetails />} />
        <Route path='/blog' element={<Blog />} />
        <Route path="/aimi" element={<Aimi />} />
        <Route path="/cloudcomputing" element={<CloudComputing />} />
        <Route path="/DataAnalytics" element={<DataAnalytics />} />
        <Route path="/DataEngineering" element={<DataEngineering />} />
        <Route path="/Data-engineering" element={<DataEngineering />} />
        <Route path="/ai-fundamentals" element={<AIFundamentals />} />
         <Route path="/data-science" element={<DataScienceCourse />} />
         <Route path="/data-sciencest" element={<DataScienceCourse />} />
         <Route path="/ai-developer" element={<AIDeveloper />} />
         <Route path="/ai-professional" element={<AiProfessional />} />
         <Route path="/aws" element={<Aws />} />
         <Route path="/azure" element={<Azure />} />
         <Route path="/gcp" element={<Gcp />} />
         <Route path="/tableau" element={<Tableau />} />
         <Route path="/looker" element={<Looker />} />
         <Route path="/powerbi" element={<PowerBi />} />
         <Route path="/fullstack-web" element={<FullStackWeb />} />
         <Route path="/oracle" element={<Oracle />} />
         <Route path="/cloud-engineering" element={<CloudEngineering />} />
         <Route path="/mobile-development" element={<MobileDevelopment />} />
         <Route path="/project-manager" element={<ProjectManager />} />
         <Route path="/programming" element={<ProgrammingCourse />} />
         <Route path="/deveops" element={<Deveops />} />
         <Route path="/blogger" element={<Blogger />} />
         <Route path="/testingblog" element={<BlogTitle />} />
         <Route path="/login" element={<Login />} />
         <Route path="/admin" element={<Admin />} />
        <Route path="/user" element={<User />} />
        <Route path="/posts/:id" element={<PostView />} />
        <Route path="/ai-image" element={<AiImage />} />

        {/* <Route path="/ai-developers" element={AIDeveloper} /> */}
        {/* Add more routes as needed */}
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
